import React, { useCallback, useRef, useEffect, useState } from 'react';

import { Form } from '@unform/web';
import { Container } from './styles';
import { hour, dateLanguage } from '../../utils/date';
import api from '../../services/api';
import Vimeo from '../Vimeo';

import PosterZoomComponent from '../PosterZoomComponent';
import { Button } from '../Button/styles';
import { rgb, rgba } from 'polished';
import Favorite from '../ClassRoomContainer/modules/Favorite';
import { FaStar, FaThumbsUp } from 'react-icons/fa';
import { useLanguage } from '../../hooks/Language';
import { urlWebsite } from '../../config';
import { useModal } from '../../hooks/Modal';
import { useToast } from '../../hooks/Toast';
import Loader from '../Loader';
import { useConfiguration } from '../../hooks/Configuration';
import Youtube from '../Youtube';
import IframePlayer from '../IframePlayer';
import { Link } from 'react-router-dom';

interface IPoster {
  _id: string;
  id: number;
  title?: string;
  author?: string;
  image?: string;
  video_type?: number;
  video_id: string;
  co_authors?: string;
  category?: string;
  have_video?: string;
  eixo?: string;
  institution?: string;
  thumb?: string;
}

interface IOption {
  page: number;
  order: Record<string, string>;
  where: Record<string, any>;
}



const PosterComponent: React.FC = () => {

const [postersCategories, setPostersCategories] = useState<Array<Record<string,any>>>([]);

  const [posters, setPosters] = useState<Array<IPoster>>([]);
  const [selectedPoster, setSelectedPoster] = useState<IPoster>({} as IPoster);
  const [openPoster, setOpenPoster] = useState(false);
  const [loading, setLoading] = useState(true);
  const [counter, setCounter] = useState(1);
  const [search, setSearch] = useState('');
  const [haveSelector, setHaveSelector] = useState(false);
  const [category, setCategory] = useState('');
  const [eixos, setEixos] = useState<Array<string>>([]);
  const { addToast } = useToast();
  const { configuration } = useConfiguration();
  const [options, setOptions] = useState<IOption>({
    page: 1,
    order: { orderBy: 'title', direction: 'asc' },
    where: {},
  });
  const { translate } = useLanguage();


  const votePoster = async (id) => {
    setLoading(true)
    try {
      await api.post(`send-poster-vote/${id}`);
      addToast({ title: 'Voto enviado com sucesso!', type: 'success' });
      setLoading(false);
    }
    catch (err) {
      addToast({ title: err?.response?.data?.message || err?.response?.data?.error || err?.response?.data?.erro || 'Erro ao enviar voto', type: 'error' });
      setLoading(false);
    }


  }

  const loadSearch = async (join = false, newOption = {} as IOption) => {

    const getOption: IOption = newOption?.page > 0 ? { ...newOption } : { ...options };

    const string = `search=${encodeURIComponent(
      search || '',
    )}&order=${encodeURIComponent(JSON.stringify(getOption.order))}&page=${getOption.page
      }&where=${encodeURIComponent(JSON.stringify(getOption.where))}`;

    //  getOption.where = { ...getOption.where, status: { "$ne": "no" } };

    const response = await api.get(`/poster-list`, {
      params: search ? {
        search,
        order: getOption?.order || { orderBy: 'title', orderDirection: 'asc' },
        where: getOption?.where,
        page: getOption.page
      } : {

        order: getOption?.order || { orderBy: 'title', orderDirection: 'asc' },
        where: getOption?.where,
        page: getOption.page
      }
    });

    if (response && response.data && response.data.rows) {
      const responseData = response.data.rows.reduce((prev, elem) => {
        elem.formatted_date = dateLanguage(elem.date);
        elem.formatted_start_hour = hour(elem.start_hour);
        elem.formatted_end_hour = hour(elem.end_hour);
        prev.push(elem);

        return prev;
      }, []);

      if (join) {
        setPosters([...posters, ...responseData]);
      } else {
        setPosters([...responseData]);
      }

      const categories : Record<string,any>[] = [];
 
responseData?.map( item => {

  const indexCat = categories?.findIndex( cat => cat?.title === item?.category);

  if(indexCat < 0){

    categories.push({
      title: item?.category,
      papers : [item]
    })

  }
  else{
    categories[indexCat].papers.push(item);
  }


})




setPostersCategories(categories)


      setCounter(response.data.count / 20 < 1 ? 1 : response.data.count / 20);
    } else {
      setPosters([]);
      setCounter(1);
    }
    setLoading(false);
  };



  const newSearch = () => {
    const newOptions = { ...options };
    newOptions.page = 1;
    setOptions({ ...newOptions });
    loadSearch();
    setSearch('');
  };

  const changeOrder = (value, direction) => {

    const newOptions = { ...options };

    newOptions.order = { orderBy: value, direction };

    setOptions(newOptions);
    loadSearch();

  }

  const loadEixos = async () => {
    const response = await api.get(`/poster-list-eixos`);


    if (response) {
      setEixos(response.data);
    }

  }

  useEffect(() => {
    const load = async () => {
      loadSearch();
    };
    load();
  }, []);

  const closePoster = () => {
    setOpenPoster(false);
  };

  const showPoster = poster => {
    setSelectedPoster(poster);
    setOpenPoster(true);
  };

  if (openPoster) {
    return (<div className='column' style={{display:'flex', paddingTop:'10px', flexDirection:'column', alignItems:'center', justifyContent:'flex-start', width: '100%', gap: '10px'}}>
      <button onClick={() => closePoster()} className='activeButton'>Voltar para a galeria</button>
      <PosterZoomComponent
        closePoster={closePoster}
        posterItem={selectedPoster}
      />
      </div>
    );
  }

  const addPage = () => {
    const newOptions = { ...options };
    newOptions.page = newOptions.page + 1;


    setOptions(state => ({ ...state, page: state.page + 1 }));

    loadSearch(true, newOptions);
  };

  const changeCategory = (column, categoryName) => {
    const newOptions = { ...options };
    if (categoryName === '') {
      newOptions.where = {};
      setOptions({ ...newOptions });
      loadSearch();
      if (categoryName === 'have_video') {
        setCategory(categoryName);
      }
      return;

    }


    const newCategory =
      newOptions.where && newOptions.where[column] === categoryName
        ? ''
        : categoryName;
    newOptions.page = 1;
    if (newCategory === '' && newOptions.where[column]) {
      delete newOptions.where[column];
    } else {
      newOptions.where[column] = newCategory;
    }

    setOptions({ ...newOptions });
    loadSearch();
    setCategory(newCategory);
  };

  const getColor = categoryName => {
    if (categoryName === 'Apresentação Oral') {
      return 'borderBlue';
    }
    if (categoryName === 'Pôster Comentado') {
      return 'borderPurple';
    }
    if (categoryName === 'Pôster Simples') {
      return 'borderGreen';
    }
  };

  return (
    <Container>
      {loading ? <Loader message='Carregando...' /> : <></>}
      <div className="posterSelector" style={{ width: '100%' }}>





        <div style={{ display: 'flex', flexWrap: 'wrap', padding: '10px', width: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.5)' }}>
          {eixos.length > 0 && <>   <label style={{ margin: '5px' }}>{translate('Eixo Temático')}</label>
            <select style={{ minHeight: '43px', margin: '5px', width: '100%', maxWidth: '400px', }} onChange={(e) => changeCategory('eixo', e.target.value)}>
              <option value={''}>{translate('Todos')}</option>
              {eixos.map(eixo => <option value={eixo}>{eixo}</option>)}

            </select> </>}



          {haveSelector && <>
            <Button
              className={category === 'Pôster: Categoria acadêmicose' ? 'activeButton' : ''}
              onClick={() => changeCategory('categoria', 'Pôster: Categoria estudante')}
              type="button"
            >
              Pôster: Categoria estudante
            </Button>
            <Button
              className={category === 'Concurso de Fotografia' ? 'activeButton' : ''}
              onClick={() => changeCategory('eixo', 'Concurso de Fotografia')}
              type="button"
            >
              Fotografia
            </Button>
           

          </>}

          <Form
            style={{ display: 'flex', alignItems: 'stretch', background: 'none' }}
            onSubmit={newSearch}
          >


            <input style={{ height: '43px', padding: '10px' }}
              name="pesquisa"
              type="text"
              placeholder={`${translate('Escreva para pesquisar')}...`}
              value={search}
              onChange={e => setSearch(e.target.value)}
            />

            <button className='buttonBigGreen' style={{ height: '43px', margin: '0px 10px', borderRadius: '5px' }} type="submit">{translate('Pesquisar')}</button>
          </Form>
          {configuration?.theme_data?.show_poster_button === 'yes' ? <div className="listHeader">

            <Link to={`/app/${configuration?.url}/dashboard`}><button style={{
              padding: "10px",
              margin: "10px", borderRadius: '5px', height: "43px"
            }} className='buttonBigGreen' title="Área de Chat" type='button'  >
              Área de Chat
            </button></Link>
          </div> : <></>}

          { /* <button style={{ padding: '5px', height: '43px', width: '43px', borderRadius: '10px', border: '0px', color: options?.order?.orderBy === 'stars' ? '#fff' : '#333', background: options?.order?.orderBy === 'stars' ? 'rgb(0,150,0)' : '#fff' }} onClick={() => { options?.order?.orderBy === 'stars' ? changeOrder('title', 'asc') : changeOrder('stars', 'desc') }}><FaStar /></button> */}
        </div>
      </div>
      <div className="mainPoster">
        {!loading && posters.length < 1 && <h2>Nenhum trabalho encontrado</h2>}


        {postersCategories?.map( item => {

          return <div style={{display:'flex', padding: '10px', flexDirection:'column', alignItems:'center', justifyContent:'center', width:'100%', gap: '10px'}}>
<h2 style={{background:'#134842', fontSize:'16px', color: '#fff', padding: '10px'}}  >{item?.title}</h2>
<div style={{ width: '100%', display:'flex', alignItems:'flex-start', justifyContent: 'center', gap:'10px', flexWrap:'wrap'}}>
 
{item?.papers.map(poster => {
          return (<div style={{ display: 'flex', alignItems: 'stretch', justifyContent: 'center', position: 'relative' }}>
            <div key={`posterDiv${poster.id}`} style={{ position: 'relative' }}
              className={`posterDisplay ${getColor(poster.category)}`}
              onClick={() => showPoster(poster)}
            ><div style={{ position: 'absolute', zIndex: 100, top: 0, left: 0, right: 0, bottom: 0, background: 'none' }} />
              {poster.have_video === 'yes' ? (
                <Youtube keyName={`poster${poster.id}`} id={poster.video_id} />
              ) : (
                <div style={{ width: '100%', height: '200px', overflowY: 'hidden' }}>
                  <img
                    className="posterImage"
                    src={`${urlWebsite}/${poster?.thumb ? poster?.thumb : poster.image}`}
                  /></div>
              )}
              <aside style={{ width: '100%', padding: '10px', marginBottom: '15px' }}>
                <p className="posterTitle">
                  <strong> {translate('Título')}: </strong>
                  {' '}
                  {poster.title}
                </p>
                <p className="posterAuthor">
                  <strong>{translate('Autores')}:</strong>
                  {' '}

                  {poster.author}
                  {poster.co_authors ? `, ${poster.co_authors}` : ''}
                </p>
                {poster?.eixo ? <strong style={{ fontSize: '10px' }}>
                  {translate('Área')}:  {' '}{poster?.eixo}
                </strong> : <></>}
              </aside>
            </div>
            <div style={{ position: 'absolute', left: '50%', zIndex: 100, bottom: '0px', transform: 'translateX(-50%)' }}>
              <div className='activeButton' onClick={() => configuration?.theme_data?.allow_poster_vote === 'open' ? votePoster(poster?._id?.toString()) : false}  > {configuration?.theme_data?.allow_poster_vote === 'open' ? <> Votar <FaThumbsUp style={{ marginLeft: '5px' }} /></> : configuration?.theme_data?.allow_poster_vote === 'finished' ? 'Votação encerrada' : 'Votação em breve'}</div>
            </div>
          </div>
          );
        })}
</div>
</div>
        })}    

        
      </div>
      <div className="mainFooter">
        {counter > options.page && (
          <Button type="button" onClick={() => addPage()}>
            {' '}
            Carregar Mais
          </Button>
        )}
      </div>
    </Container>
  );
};
export default PosterComponent;
